/* =============================================
 * Public methods
 * ============================================= */

/**
 * Stores a value with a given key in local storage, or session storage if local storage is unavailable, or as a cookie if session storage is unavailable
 * @param {String} key The key to store the value under
 * @param {String} value The value to store
 */
const storeValueWithKey = (key, value) => {
  try {
    if (window.localStorage) {
      window.localStorage.setItem(key, value)
    }

    if (window.sessionStorage) {
      window.sessionStorage.setItem(key, value)
    }

    document.cookie = `${key}=${value}`
  } catch (e) {
    // Do nothing
    console.error(e)
  }
}

/**
 * Retrieves a value with a given key from local storage, or session storage if local storage is unavailable, or as a cookie if session storage is unavailable
 * @param {String} key The key to retrieve the value for
 * @returns {String} The value stored under the given key
 */
const getValueForKey = key => {
  try {
    if (window.localStorage && window.localStorage.getItem(key)) {
      return window.localStorage.getItem(key)
    }

    if (window.sessionStorage && window.sessionStorage.getItem(key)) {
      return window.sessionStorage.getItem(key)
    }

    return document.cookie
      .split('; ')
      .find(row => row.startsWith(`${key}=`))
      .split('=')[1]
  } catch (e) {
    // Do nothing
    console.error(e)
  }

  return null
}

/**
 * Removes a value with a given key from local storage, or session storage if local storage is unavailable, or as a cookie if session storage is unavailable
 * @param {String} key The key to remove the value for
 */
const removeValueForKey = key => {
  try {
    if (window.localStorage) {
      window.localStorage.removeItem(key)
    }

    if (window.sessionStorage) {
      window.sessionStorage.removeItem(key)
    }

    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  } catch (e) {
    // Do nothing
    console.error(e)
  }
}

export { storeValueWithKey, getValueForKey, removeValueForKey }
